module.exports = __webpack_public_path__ + "img/auction_detail_bg.8687a15d.png";